export default __webpack_public_path__ + "static/media/newspaper-variant-outline.0af1aade.svg";